import { render, staticRenderFns } from "./TastyBlock.vue?vue&type=template&id=3dfb7353&scoped=true"
import script from "./TastyBlock.vue?vue&type=script&lang=js"
export * from "./TastyBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb7353",
  null
  
)

export default component.exports